
import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";

export interface ICouponserviceSubServiceResponseData {
  sub_service_id: string;
  sub_service_name: string;
}
export interface ICouponserviceSubServiceResponse {
  status: boolean;
  message: string;
  data: ICouponserviceSubServiceResponseData[];
}

type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

AxiosCurlirize(axios, () => {});

export const useCouponSubServiceListAPICoupon = () => {
  const [subServiceList, setSubServiceList] = useState<ICouponserviceSubServiceResponseData[]>([]);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (vms_subcategory_id: string, vms_category_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(
            `${COUPON_SERVICE_APIS?.COUPON_SUB_SERVICE_LIST_POST?.baseURL}`,
            {
              vms_category_id: vms_category_id,
              vms_subcategory_id: vms_subcategory_id,
            },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<ICouponserviceSubServiceResponse>) => {
            if (res.data.status) {
              setSubServiceList(res.data.data);
              return { status: true, message: null };
              //
            } else {
              setSubServiceList([]);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              setSubServiceList([]);
              return { status: false, message: null };
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              setSubServiceList([]);
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              setSubServiceList([]);
              // toast.error("Server error 500");
            }
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
        setSubServiceList([]);
      }
    },
    [dispatch],
  );
  return { execute, subServiceList };
};